AccessController = App.loadClass 'admin::Angular/AccessController'

class exports.UploadsController extends AccessController
    constructor: (@scope, @transitions, @service, @http) ->
        super('uploads', @http)

        @scope.title = 'Uploads'
        @scope.fullpage = true
        @scope.absolute_errors = true

        @scope.user_id = null
        @scope.file_id = null

        @scope.users = []
        @scope.files = []

        @scope.userChanged = @userChanged
        @scope.deleteFile = @deleteFile

        @service.getUsers().then (response) =>
            @scope.users = response.data.data

    userChanged: () =>
        # clear the selected file
        @scope.file_id = null

        # update files when the user changes
        @service.getFiles(@scope.user_id).then (response) =>
            @scope.files = response.data.data

    deleteFile: () =>
        # delete the selected file
        @service.deleteFile(@scope.file_id).then (response) =>
            if response.data.data
                @setAlert({ type: 'success', msg: 'File successfully deleted' }, [], 2500)
            else
                @setAlert({ type: 'danger', msg: 'Failed to delete file' }, [], 2500)

            # refresh the files list
            @service.getFiles(@scope.user_id).then (response) =>
                @scope.files = response.data.data



